var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getHeaders } from './apiUtils';
import { API_PATHS } from '../types/apiPaths';
export var buildReviewQueueParams = function (params) {
    var searchParams = new URLSearchParams();
    Object.entries(params).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if (Array.isArray(value)) {
            // CZNA-1421 — `sigla` is repeatable: one parameter per value, never a joined string.
            // CZNA-1644 — and so is `kind`.
            value.forEach(function (item) { return searchParams.append(key, String(item)); });
        }
        else if (value !== undefined && value !== null) {
            searchParams.set(key, String(value));
        }
    });
    return searchParams;
};
export var fetchReviewQueue = function (ky, params) {
    if (params === void 0) { params = {}; }
    var searchParams = buildReviewQueueParams(__assign({ offset: 0, limit: 50, sortBy: 'WAITING_SINCE', sortOrder: 'ASC' }, params));
    return ky.get("".concat(API_PATHS.CZNA_AUTHORITIES_REVIEW_QUEUE, "?").concat(searchParams), {
        headers: getHeaders(),
    }).json();
};
export var fetchReturnedQueue = function (ky, params) {
    if (params === void 0) { params = {}; }
    var searchParams = buildReviewQueueParams(__assign({ offset: 0, limit: 50, sortBy: 'WAITING_SINCE', sortOrder: 'DESC' }, params));
    return ky.get("".concat(API_PATHS.CZNA_AUTHORITIES_RETURNED_QUEUE, "?").concat(searchParams), {
        headers: getHeaders(),
    }).json();
};
var withQuery = function (path, params) {
    var query = buildReviewQueueParams(params).toString();
    return query ? "".concat(path, "?").concat(query) : path;
};
/**
 * CZNA-1421 — the sigla facet of the Inbox (`inbox`) or of "Všechny kontroly" (`all`).
 * CZNA-1644 — counted under the chosen kinds.
 */
export var fetchReviewQueueSiglas = function (ky, mode, kinds) {
    if (kinds === void 0) { kinds = []; }
    return ky.get(withQuery(mode === 'inbox'
        ? API_PATHS.CZNA_AUTHORITIES_RETURNED_QUEUE_SIGLAS
        : API_PATHS.CZNA_AUTHORITIES_REVIEW_QUEUE_SIGLAS, { kind: kinds }), { headers: getHeaders() }).json();
};
/** CZNA-1644 — the kind facet of the matching view, counted under the chosen siglas. */
export var fetchReviewQueueKinds = function (ky, mode, siglas) { return ky.get(withQuery(mode === 'inbox'
    ? API_PATHS.CZNA_AUTHORITIES_RETURNED_QUEUE_KINDS
    : API_PATHS.CZNA_AUTHORITIES_REVIEW_QUEUE_KINDS, {
    sigla: siglas.siglas,
    withoutSigla: siglas.withoutSigla || undefined,
}), { headers: getHeaders() }).json(); };
